import { defineMessages } from "react-intl"

export const inventoryListFilterMessages = defineMessages({
	accidentFree: {
		defaultMessage: "Accident free",
		id: "vehicle.condition.accidentFree",
	},
	bodyType: {
		defaultMessage: "Body Type",
		id: "inventoryListFilters.bodyType.heading",
	},
	condition: {
		defaultMessage: "Condition",
		id: "inventoryListFilters.condition.heading",
	},
	driveTrains: {
		defaultMessage: "Drive Trains",
		id: "inventoryListFilters.driveTrains.heading",
	},
	engineAndTransmission: {
		defaultMessage: "Engine & Transmission",
		id: "inventoryListFilters.engineAndTransmission.heading",
	},
	engineTypes: {
		defaultMessage: "Engine Types",
		id: "inventoryListFilters.engineTypes.heading",
	},
	equipment: {
		defaultMessage: "Equipment",
		id: "inventoryListFilters.equipment.heading",
	},
	exteriorColor: {
		defaultMessage: "Exterior Color",
		id: "inventoryListFilters.exteriorColor.heading",
	},
	firstRegistration: {
		defaultMessage: "First Registration",
		id: "inventoryListFilters.firstRegistration.heading",
	},
	goodQuality: {
		defaultMessage: "Good quality",
		id: "inventoryListFilters.listingQuality.goodQuality",
	},
	horsepower: {
		defaultMessage: "PS",
		id: "inventoryListFilters.horsepower.option",
	},
	interiorColor: {
		defaultMessage: "Interior Color",
		id: "inventoryListFilters.interiorColor.heading",
	},
	kilowatt: {
		defaultMessage: "kW",
		id: "inventoryListFilters.kilowatt.option",
	},
	listingQuality: {
		defaultMessage: "Listing Quality",
		id: "inventoryListFilters.listingQuality.heading",
	},
	listingVisibility: {
		defaultMessage: "Listing Visibility",
		id: "inventoryListFilters.listingVisibility.heading",
	},
	location: {
		defaultMessage: "Location",
		id: "inventoryListFilters.location.heading",
	},
	lowQuality: {
		defaultMessage: "Low quality",
		id: "inventoryListFilters.listingQuality.lowQuality",
	},
	maxFirstRegistrationDate: {
		defaultMessage: "To year",
		id: "inventoryListFilters.maxFirstRegistrationDate.label",
	},
	maxMileage: {
		defaultMessage: "Max. Mileage",
		id: "inventoryListFilters.maxMileage.label",
	},
	maxModelYear: {
		defaultMessage: "Max. Model Year",
		id: "inventoryListFilters.maxModelYear.label",
	},
	maxPreviousOwners: {
		defaultMessage: "Max. Previous Owners",
		id: "inventoryListFilters.maxPreviousOwners.label",
	},
	maxPrice: {
		defaultMessage: "Max. Price",
		id: "inventoryListFilters.maxPrice.label",
	},
	mediumQuality: {
		defaultMessage: "Medium quality",
		id: "inventoryListFilters.listingQuality.mediumQuality",
	},
	mileage: {
		defaultMessage: "Mileage",
		id: "inventoryListFilters.mileage.heading",
	},
	minEnginePower: {
		defaultMessage: "Min. Power",
		id: "inventoryListFilters.minEnginePower.label",
	},
	minFirstRegistrationDate: {
		defaultMessage: "From year",
		id: "inventoryListFilters.minFirstRegistrationDate.label",
	},
	minModelYear: {
		defaultMessage: "Min. Model Year",
		id: "inventoryListFilters.minModelYear.label",
	},
	modelGenerations: {
		defaultMessage: "Model Generations",
		id: "inventoryListFilters.modelGenerations.heading",
	},
	modelSeries: {
		defaultMessage: "Model Series",
		id: "inventoryListFilters.modelSeries.heading",
	},
	modelSeriesAllModels: {
		defaultMessage: "All Models",
		id: "inventoryListFilters.modelSeries.allModels",
	},
	modelVariants: {
		defaultMessage: "Model Variants",
		id: "inventoryListFilters.modelVariants.heading",
	},
	noModelGenerations: {
		defaultMessage: "Select a model first so you can filter model generations like 992.",
		id: "inventoryListFilters.modelGenerations.noModelSeriesSelected",
	},
	noModelVariants: {
		defaultMessage: "Select a model first so you can filter model variants like 911 Carrera S.",
		id: "inventoryListFilters.modelVariants.noModelSeriesSelected",
	},
	onlineOrderableStatus: {
		defaultMessage: "Online ordering",
		id: "inventoryListFilters.onlineOrderableStatus.heading",
	},
	previousOwners: {
		defaultMessage: "Previous Owners",
		id: "inventoryListFilters.previousOwners.heading",
	},
	price: {
		defaultMessage: "Price",
		id: "inventoryListFilters.price.heading",
	},
	salesStatus: {
		defaultMessage: "Sales Status",
		id: "inventoryListFilters.salesStatus.heading",
	},
	search: {
		defaultMessage: "Search",
		id: "inventoryListFilters.search.heading",
	},
	stockStatus: {
		defaultMessage: "Stock Status",
		id: "inventoryListFilters.stockStatus.heading",
	},
	transmissions: {
		defaultMessage: "Transmissions",
		id: "inventoryListFilters.transmissions.heading",
	},
	vatDeductible: {
		defaultMessage: "VAT deductible",
		id: "inventoryListFilters.vatDeductible.label",
	},
	year: {
		defaultMessage: "Year",
		id: "inventoryListFilters.year.heading",
	},
})
